export function removeIndustrialCity(cityName: string) {
    const regex = /\s*Industrial\s*City$/i;
    const hasIndustrialCity = regex.test(cityName);
    const cleanedCityName = cityName.replace(regex, "").trim();

    return {
        cleanedName: cleanedCityName,
        wasRemoved: hasIndustrialCity,
    };
}